import { CSSObject } from '@emotion/core';

import { scale } from '@scripts/gds';

export const filterItemContainerStyles: CSSObject = {
    marginBottom: '16px',
    ':last-child': {
        marginBottom: 0,
    },
};

export const booleanFilterContainerStyles: CSSObject = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
};

export const booleanFilterFieldWrapperStyles: CSSObject = {
    width: scale(6),
    flexShrink: 0,
};

export const booleanFilterTitleStyles: CSSObject = {
    margin: 0,
};
